





































import Vue from 'vue'
import DropdownArrow from '@/assets/svgs/dropdown_arrow.svg?inline'
import NearMeIcon from '@/assets/svgs/near_me_icon.svg?inline'
import Checkmark from '@/assets/svgs/checkmark.svg?inline'

interface Data {
  selected: string
  open: boolean
}

interface Props {
  id?: string
  options: Array<Record<string, unknown>>
  startingValue: string
  title: string
  placeholder: string
  icon: boolean
  tabindex: number
  checkmark: boolean
  inputName: string
  rules?: (() => boolean)[]
  required: boolean
}

interface Methods {}

interface Computed {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Dropdown',
  props: {
    id: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    startingValue: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    icon: {
      type: Boolean,
      required: false,
      default: false
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    checkmark: {
      type: Boolean,
      required: false,
      default: false
    },
    inputName: {
      type: String,
      required: false,
      default: ''
    },
    rules: Array,
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    DropdownArrow,
    NearMeIcon,
    Checkmark
  },
  watch: {
    startingValue: {
      handler: function (newVal) {
        this.selected = newVal
      }
    }
  },
  data: function () {
    return {
      selected: this.startingValue || '',
      open: false
    }
  }
})
